import { DataService } from './dataService'

const AdditonalChargesService = {
	getCourieraddionalcharges: async (data) => {
		return DataService.get('/admin/get_additional_charges', data)
	},
	getCourierrates: async (data) => {
		return DataService.get('/admin/get_courier_charge', data)
	},
	updateCourierrates: async (data) => {
		return DataService.post('/admin/update_courier_charge', data)
	},
	updateCourieraddionalcharges: async (data) => {
		return DataService.post('/admin/update_additional_charges', data)
	}
}

export default AdditonalChargesService